<div class="myModal">
	<div class="modal-header">
		<button (click)="exitModal(false)" class="close" aria-label="close">
			<span>{{ labelsKeys.fermer | translate }}</span>
			<mat-icon aria-hidden="true">close</mat-icon>
		</button>
	</div>
	<div class="modal-body">
		<p style="font-size: 0.875em;">{{ labelsKeys.intro | translate }}</p>
		<div>{{ labelsKeys.referenceAvisLabel | translate }} {{referenceAvis}}</div>
		<div>{{ labelsKeys.objetLabel | translate }} {{objetAvis}}</div>
		<div>{{ labelsKeys.familleLabel | translate }} {{familleFormulaire}}</div>

		<p class="mt-3">
			<strong>{{ labelsKeys.refConsultationInfo | translate }}</strong> : {{refConsultation || 'N/A'}}
		</p>
		<p class="mt-3" style="font-style: italic; font-size: 0.875em; white-space: pre-line;">
			{{ labelsKeys.refConsultationHelp | translate }}
		</p>
	</div>
	<div class="modal-footer">
		<button aria-label="Annuler" (click)="exitModal(false)"
			class="btn btn-outline-primary mr-auto">{{ labelsKeys.annuler | translate }}</button>
		<button aria-label="Valider" (click)="exitModal(true)"
			class="btn btn-primary ml-3">{{ labelsKeys.valider | translate }}</button>
	</div>
</div>
